var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.087 30.7875C13.087 21.1226 20.9221 13.2875 30.587 13.2875M41.8368 19.5375L30.5868 30.7875M55.587 30.7875C55.587 44.5945 44.394 55.7875 30.587 55.7875C16.7799 55.7875 5.58704 44.5945 5.58704 30.7875C5.58704 16.9804 16.7799 5.78754 30.587 5.78754C44.394 5.78754 55.587 16.9804 55.587 30.7875ZM33.087 30.7875C33.087 32.1683 31.9678 33.2875 30.587 33.2875C29.2063 33.2875 28.087 32.1683 28.087 30.7875C28.087 29.4068 29.2063 28.2875 30.587 28.2875C31.9678 28.2875 33.087 29.4068 33.087 30.7875Z",
    stroke: "#F36F45",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimer);
export default __webpack_public_path__ + "static/media/icon_timer.06f8a18f81fc6395361ffb280b392026.svg";
export { ForwardRef as ReactComponent };